import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';
import invariant from 'tiny-invariant';

import { DriverFormPreferences } from './_authenticated._main.driver.preferences/DriverFormPreferences';
import { Spinner } from '../components/Spinner';
import { useFetchDriver } from '../hooks/useFetchDriver';
import { useFetchDriverPreferencesById } from '../hooks/useFetchDriverPreferencesById';
import { t } from '../services/translation/translation';
import { getFullName } from '../utils/common';

export const DriverPreferencesRoute = () => {
  const { driverKey } = useParams();

  invariant(driverKey);

  const { data: driver, isLoading } = useFetchDriver(driverKey);
  const { data: driverPreferenceData, isLoading: isLoadingPreferences } = useFetchDriverPreferencesById(driverKey);

  if (isLoading) {
    return (
      <div className="w-full h-screen flex items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (!driver) {
    return (
      <div>
        <h3 className="text-3xl font-bold dark:text-white mb-6">{t('common.error')}</h3>
        <div className="inline-block space-y-2">
          <div className="h-96 w-96 bg-confused-light dark:bg-confused-dark bg-no-repeat bg-contain bg-center" />
          <p className="text-center">{t('driver-route.not-found')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-screen-lg m-auto">
      <Helmet>
        <title>{getFullName(driver.firstName, driver.lastName)} - Allocab</title>
      </Helmet>
      <h3 className="text-3xl font-bold dark:text-white mb-6">
        {t('common.package-preference')}
        {' : '}
        {getFullName(driver.firstName, driver.lastName)}
      </h3>
      <>
        {isLoadingPreferences ? (
          <div className="flex justify-center mt-12">
            <Spinner />
          </div>
        ) : driverPreferenceData ? (
          <DriverFormPreferences driverPreferenceData={driverPreferenceData} />
        ) : null}
      </>
    </div>
  );
};
